import React from "react";

const AppStore = ({size=24,  ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M14.4993 7.80264C15.0453 7.59762 15.5709 7.42483 16.3055 7.41589C16.3238 7.41689 16.3422 7.4174 16.3608 7.4174C17.1514 7.4174 18.0376 7.74175 18.8266 8.38759C18.8238 8.39385 18.8205 8.40051 18.8168 8.40753C18.7972 8.44421 18.7698 8.48018 18.7378 8.51002C16.0786 10.9869 16.5972 15.3144 19.5001 17.257C19.5748 17.307 19.623 17.3751 19.6415 17.4246C19.6449 17.4337 19.6468 17.4406 19.6478 17.4454C19.416 17.9201 19.194 18.308 18.8001 18.9075L18.7999 18.9079C18.3638 19.5722 17.8837 20.2469 17.356 20.7534C16.822 21.266 16.3594 21.4906 15.9571 21.4965H15.9351C15.5409 21.4965 15.3134 21.3927 14.8518 21.182C14.8244 21.1696 14.7963 21.1567 14.7672 21.1435C14.2152 20.8924 13.5195 20.611 12.4083 20.611H12.3801V20.611L12.3746 20.611C11.2557 20.6172 10.5493 20.8971 9.9881 21.146C9.95879 21.159 9.93036 21.1717 9.90273 21.184C9.42747 21.3953 9.18838 21.5016 8.78622 21.5016H8.76413C8.33412 21.4956 7.88098 21.2837 7.38075 20.8245C6.87764 20.3627 6.4173 19.733 5.98565 19.0729L5.98546 19.0726C4.83816 17.3195 4.21171 15.4235 4.04487 13.7141C3.87635 11.9874 4.18277 10.5409 4.78399 9.613C5.71833 8.17856 7.13574 7.42209 8.34372 7.42209C8.97637 7.42209 9.50175 7.59073 10.1258 7.81217C10.165 7.82608 10.205 7.84038 10.2457 7.85496C10.8171 8.05928 11.539 8.3174 12.3604 8.3174C13.1534 8.3174 13.8152 8.06409 14.3354 7.86501C14.3917 7.84345 14.4463 7.82254 14.4993 7.80264Z"
                stroke="black"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M15.9492 1.5C14.8242 1.57641 13.5117 2.29266 12.743 3.22781C12.0455 4.07531 11.4717 5.3325 11.6967 6.55172H11.7867C12.9848 6.55172 14.2111 5.83031 14.9273 4.90594C15.6173 4.02609 16.1405 2.77922 15.9492 1.5Z"
                fill="black"
            />
        </svg>
    );
};

export default AppStore;
